import { ApiClient } from '@ahaslides-product/plugins-api'
import configs from '@/config'

const getAggregation = (subject, teamScoringRule) => {
  if (subject === 'team') {
    if (teamScoringRule === 'average') {
      return 'average_score'
    }
    if (teamScoringRule === 'fastest') {
      return 'first_score'
    }
  }
  return 'total_score'
}

// Ranked board over the slide window — cumulative standings up to the current leaderboard slide.
const getLeaderboardSlideTopN = async ({
  presentationId,
  presentationVersion,
  subject,
  teamScoringRule,
  slideIds,
  lastSlideId,
  n,
}) => {
  const aggregation = getAggregation(subject, teamScoringRule)
  const client = new ApiClient(configs.kvSyncApiUrl)
  const res = await client.getLeaderboardSlideTopN({
    presentationId,
    presentationVersion,
    slideIds,
    lastSlideId,
    subject,
    n,
    aggregation,
  })
  const items = res?.aggregations?.[aggregation]?.items || []
  if (subject === 'team') {
    return {
      teams: items.map((item) => ({
        id: item.id,
        name: item.name,
        totalPoint: item.score,
        index: item.rank,
        members: item.members || [],
      })),
    }
  }
  return {
    audiences: items.map((item) => ({
      audience: item.id,
      audienceName: item.name,
      audienceEmoji: item.emoji,
      teamId: item.teamId,
      totalPoint: item.score,
      index: item.rank,
    })),
  }
}

// The current subject's own standing from the slide-around window. Returns null when the subject
// isn't in the window. The pivot carries answerCount/correctAnswerCount for participant and team
// subjects; streaks come through only for participants.
const getLeaderboardSlideAround = async ({
  presentationId,
  presentationVersion,
  subject,
  subjectId,
  teamScoringRule,
  slideIds,
  k,
}) => {
  const aggregation = getAggregation(subject, teamScoringRule)
  const client = new ApiClient(configs.kvSyncApiUrl)
  const res = await client.getLeaderboardSlideAround({
    presentationId,
    presentationVersion,
    slideIds,
    subject,
    subjectId,
    k,
    aggregation,
  })
  const self = (res?.items || []).find((item) => item.id === subjectId)
  if (!self) return null
  const answerCount = self.answerCount || 0
  const correctAnswerCount = self.correctAnswerCount || 0
  return {
    audienceName: self.name,
    audienceEmoji: self.emoji,
    totalPoint: self.score,
    index: self.rank,
    answerCount,
    correctAnswerCount,
    correctRate: answerCount > 0 ? correctAnswerCount / answerCount : 0,
    currentStreak: self.currentStreak || 0,
    longestStreak: self.longestStreak || 0,
  }
}

export default {
  getLeaderboardSlideTopN,
  getLeaderboardSlideAround,
}
